import { render, staticRenderFns } from "./PTrucktype.vue?vue&type=template&id=47422675"
import script from "./PTrucktype.vue?vue&type=script&lang=js"
export * from "./PTrucktype.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports